import React from 'react';

const MediaButton = ({ value, mediaType, index, onClick }) => {

  const renderPreview = () => {
    if (!value) {
      return (
        <div className="flex flex-col items-center justify-center h-full">
          <svg className="w-8 h-8 text-gray-500 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mediaType === 'image' ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            ) : mediaType === 'video' ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
            )}
          </svg>
          <span className="text-xs text-gray-500">
            {mediaType === 'image' ? 'Image' : mediaType === 'video' ? 'Video' : 'Audio'}
          </span>
        </div>
      );
    }

    switch (mediaType) {
      case 'image':
        return (
          <img
            crossOrigin='anonymous'
            src={value}
            alt={`Preview ${index + 1}`}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = '<div class="text-xs text-red-500">Failed to load</div>';
            }}
          />
        );
      
      case 'video':
        return (
          <video
            crossOrigin='anonymous'
            src={value}
            className="w-full h-full object-cover"
            muted
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = '<div class="text-xs text-red-500">Failed to load</div>';
            }}
          />
        );
      
      case 'audio':
        return (
          <div className="flex flex-col items-center justify-center h-full bg-gradient-to-br from-purple-600 to-blue-600">
            <svg className="w-8 h-8 text-white mb-1" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
            </svg>
            <span className="text-xs text-white truncate max-w-full px-1">
              {value.split('/').pop().split('?')[0]}
            </span>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="relative group">
      <button
        onClick={onClick}
        className={`
          w-20 h-20 rounded-lg overflow-hidden transition-all
          ${value ? 'border-2 border-gray-600' : 'border-2 border-dashed border-gray-600'}
          hover:border-ag-green hover:scale-105
          bg-ag-black-800
        `}
        title={value || `Click to select ${mediaType}`}
      >
        {renderPreview()}
        
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </div>
      </button>

      {/* Field number label */}
      <div className="absolute -top-2 -right-2 bg-ag-green text-black text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
        {index + 1}
      </div>
    </div>
  );
};

export default MediaButton;